import ChatWifiBox  from './ChatWifiBox';

export default ChatWifiBox;
